var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEntLogoLight(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_590_1",
    "data-name": "Component 590 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 151.489,
    height: 37,
    viewBox: "0 0 151.489 37",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1",
    "data-name": "Rectangle 1",
    width: 151.489,
    height: 37,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M65.6,27.448c-.025.173-.074.2-.222.2H55.571c-.173,0-.222-.074-.222-.2v-15.8c0-.123.049-.2.2-.2h9.516c.148,0,.2.025.222.173l.272,2.292c.025.124-.025.223-.173.223H58.332v3.92h6.41c.123,0,.172.025.172.173V20.57c0,.123-.074.148-.172.148h-6.41v4.239H65.8c.148,0,.2.075.173.2Z",
    transform: "translate(-5.059 -1.047)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M69.556,18.709c0-.839-.049-2.17-.1-2.662,0-.124.025-.174.173-.174h2.243c.172,0,.246.049.3.174a5.279,5.279,0,0,1,.173.936,5.439,5.439,0,0,1,3.575-1.356c1.849,0,4.117.937,4.117,4.882v7.3c0,.173-.075.222-.2.222H77.273a.2.2,0,0,1-.222-.222V20.78c0-1.627-.691-2.564-2.121-2.564a3.158,3.158,0,0,0-2.391,1.01v8.6a.181.181,0,0,1-.2.2H69.753c-.148,0-.2-.074-.2-.2Z",
    transform: "translate(-6.349 -1.429)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M85.843,14.136h-5c-.124,0-.173-.075-.148-.2l.321-2.292c.025-.148.074-.2.222-.2H93.485c.148,0,.222.049.247.222l.222,2.243c.025.148-.05.223-.173.223H88.8V27.424c0,.148-.074.222-.2.222h-2.54c-.173.025-.222-.05-.222-.222Z",
    transform: "translate(-7.375 -1.047)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M97.944,15.873a.243.243,0,0,1,.271.2,5.554,5.554,0,0,1,.247,1.479,5.137,5.137,0,0,1,3.944-1.923c.148,0,.2.025.2.172v2.613c0,.124-.049.174-.222.174a4.787,4.787,0,0,0-3.772,1.307V27.83c0,.148-.075.2-.222.2H95.824c-.173,0-.223-.074-.223-.2V19.325c0-1.06-.025-2.49-.123-3.3,0-.123.025-.147.148-.147Z",
    transform: "translate(-8.727 -1.429)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M115.768,25.34a21.713,21.713,0,0,0,.148,2.54c.025.124-.05.173-.2.173H113.45c-.172,0-.222-.049-.246-.148a5.367,5.367,0,0,1-.173-.862,4.872,4.872,0,0,1-3.426,1.257c-2.342,0-4.142-1.257-4.142-4.708v-7.52c0-.148.049-.173.2-.173h2.589c.148,0,.173.049.173.173v7.174c0,1.529.666,2.465,2.145,2.465a3.129,3.129,0,0,0,2.243-.887V16.071c0-.124.049-.173.2-.173H115.6c.148,0,.173.049.173.173Z",
    transform: "translate(-9.64 -1.453)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M124.513,18.017c-1.307,0-1.75.542-1.75,1.06,0,.542.37.911,1.948,1.528,2.81,1.036,3.772,2.145,3.772,3.9,0,2.318-1.824,3.772-4.856,3.772a7.584,7.584,0,0,1-3.476-.691c-.124-.075-.173-.124-.173-.271V24.97a.128.128,0,0,1,.2-.124,6.717,6.717,0,0,0,3.525.987c1.281,0,1.9-.444,1.9-1.085,0-.617-.468-1.011-2-1.627-2.687-.986-3.648-2.1-3.648-3.871,0-1.874,1.528-3.624,4.609-3.624a7.607,7.607,0,0,1,3.106.493.3.3,0,0,1,.148.3v2.17c0,.124-.074.2-.222.148a7.019,7.019,0,0,0-3.082-.715",
    transform: "translate(-10.964 -1.428)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M137.922,27.295c0,.147-.025.246-.147.3a5.66,5.66,0,0,1-2.1.345c-2.022,0-3.229-.986-3.229-3.427V18.026H130.9c-.124-.025-.173-.075-.173-.223V15.732c0-.148.049-.2.2-.2h1.554a25.943,25.943,0,0,1,.246-3.032c.025-.124.074-.2.2-.222l2.49-.345c.123-.025.172,0,.172.124-.074.813-.124,2.268-.124,3.475h2.391c.124,0,.174.049.174.173v2.144c0,.124-.05.174-.174.174h-2.416v5.842c0,1.085.345,1.6,1.406,1.6a4.157,4.157,0,0,0,.938-.1c.073-.025.147,0,.147.148Z",
    transform: "translate(-11.949 -1.09)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M143.362,22.629c.074,1.725,1.208,3.106,3.723,3.106a7.769,7.769,0,0,0,3.057-.591c.074-.05.148-.025.148.1v2.046a.262.262,0,0,1-.148.271,8.191,8.191,0,0,1-3.7.715c-4.487,0-6.089-3.156-6.089-6.188,0-3.427,2.071-6.46,5.794-6.46a4.9,4.9,0,0,1,5.053,5.2,7.429,7.429,0,0,1-.1,1.528.212.212,0,0,1-.2.173,18.818,18.818,0,0,1-2.54.1Zm3.673-2.121a11.687,11.687,0,0,0,1.356-.025v-.2a2.28,2.28,0,0,0-2.366-2.293,2.694,2.694,0,0,0-2.663,2.515Z",
    transform: "translate(-12.829 -1.428)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M154.491,21.542c0-3.574,2.662-6.434,7-6.434a8.582,8.582,0,0,1,1.06.074V10.129c0-.124.049-.173.147-.173h2.688c.123,0,.123.049.123.147V24.994c0,.493.05,1.134.1,1.578a.192.192,0,0,1-.147.222,11.687,11.687,0,0,1-4.66.961c-3.574,0-6.311-2.071-6.311-6.213m8.062-3.772a3.294,3.294,0,0,0-1.159-.173,3.609,3.609,0,0,0-3.845,3.8c0,2.688,1.6,3.8,3.574,3.8a4.56,4.56,0,0,0,1.43-.2Z",
    transform: "translate(-14.121 -0.91)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M23.04.571A18.5,18.5,0,1,0,36.429,23.04,18.5,18.5,0,0,0,23.04.571M17.809,9.364l5.94-.083a2.819,2.819,0,0,1,2.771,3.511l-13.285.184a4.785,4.785,0,0,1,4.574-3.612M7,17.726a1.772,1.772,0,0,1,1.695-1.338l9.613-.133a1.774,1.774,0,0,1,.05,3.547l-9.613.134A1.775,1.775,0,0,1,7,17.726m12.342,8.961-5.939.082a2.819,2.819,0,0,1-2.772-3.51l13.285-.184a4.785,4.785,0,0,1-4.575,3.612m7.739-8.776a2.575,2.575,0,0,1-2.356,1.81,1.363,1.363,0,0,1-1.452-1.757,2.572,2.572,0,0,1,2.354-1.81,1.365,1.365,0,0,1,1.454,1.757",
    transform: "translate(0 0)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEntLogoLight);
export default __webpack_public_path__ + "static/media/ent-logo-light.78dbf32a5a14de2da1b9c248fd19623f.svg";
export { ForwardRef as ReactComponent };